import React from 'react';
import { useStandings } from '../hooks/standings';
import { useTeamLogos } from '../hooks/team';
import StandingsRow from '../components/Standings/StandingsRow';

export default function StandingsTableBody() {
  const [standings, loading, error] = useStandings('total');
  const [teamLogos, loadingTeamLogos, errorTeamLogos] = useTeamLogos();

  if (!standings || !teamLogos || loading || loadingTeamLogos) return null;

  return standings?.map((item) => (
    <StandingsRow
      data={item}
      key={item.id}
      logo={teamLogos[item.abbrv]?.logoImageUrl}
    />
  ));
}
